import {ApiProperty} from "@nestjs/swagger";

export class RequestReport{

    @ApiProperty()
    fromDate: string;

    @ApiProperty()
    toDate : string;
}